<dw-ui-panel [defaultOpenedPanel]="info" [triggers]="triggers()">
  @if (entitySignal()?.id) {
    <div header-start class="mx-3">
      <document-number-tag [docRole]="entitySignal().role" [number]="entitySignal().displayNumber">
      </document-number-tag>
    </div>
  }

  <dw-grid-detail-navigation
    header-actions
    [context]="[
      GoliathDocumentEntityNames.SupplierDeliveryNote.shortName,
      GoliathDocumentEntityNames.CustomerDoc.shortName,
    ]"
  >
  </dw-grid-detail-navigation>
  <dw-grid-tabs>
    <div class="tabs">
      <ul
        ngbNav
        #nav="ngbNav"
        (navChange)="onTabChanged($event.nextId)"
        class="nav-underline nav-tabs d-flex border-0 me-md-auto"
      >
        <li [ngbNavItem]="'general'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-alert-info me-2 text-primary"></i>{{ '::General' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <div ngbScrollSpy #spy="ngbScrollSpy" #scrollSpy>
              <div class="mt-2 container-panel">
                <form
                  id="generalForm"
                  [formGroup]="form"
                  [DwKeyboardShortcut]="shortcut.controlS"
                  (shortcutAction)="save()"
                >
                  <div class="card-group mb-3 mt-2 header">
                    <document-core-card
                      [form]="form"
                      [entity]="entity"
                      [readonlyForm]="
                        entity?.deliveryStatus == SupplierDeliveryStatus.CheckValuation ||
                        entity?.deliveryStatus == SupplierDeliveryStatus.Closed
                      "
                      [dayBookLabel]="'Doc::DayBookReception'"
                      class="card"
                    ></document-core-card>

                    <document-supplier-document-date-card
                      [form]="form"
                      [readonlyForm]="entity?.deliveryStatus == SupplierDeliveryStatus.Closed"
                      class="card"
                    >
                      <div class="row row-cols-md-12">
                        <div class="col-md-12 p-0">
                          <label for="receivedDate" class="form-label text-primary">
                            {{ 'Doc::SupplierDeliveryNote:ReceivedDate' | abpLocalization }}
                          </label>
                          <dw-core-date-picker
                            name="receivedDate"
                            formControlName="receivedDate"
                          ></dw-core-date-picker>
                        </div>
                      </div>
                    </document-supplier-document-date-card>

                    <document-supplier-card
                      [form]="form"
                      [thirdPartySelect]="thirdPartySelect"
                      [thirdPartyContacts$]="thirdPartyContacts$"
                      [currencyRateReadonly]="
                        entity?.deliveryStatus == SupplierDeliveryStatus.Closed
                      "
                      [readonlyForm]="
                        entity?.deliveryStatus == SupplierDeliveryStatus.CheckValuation ||
                        entity?.deliveryStatus == SupplierDeliveryStatus.Closed
                      "
                      class="card card-double"
                    >
                      <div class="row row-cols-md-12 col-pad" bottom>
                        <div class="col-md-6 p-0">
                          <label for="reference" class="form-label text-primary">
                            {{ 'Doc::CustomerReference' | abpLocalization }}
                          </label>
                          <input type="text" class="form-control" formControlName="reference" />
                        </div></div
                    ></document-supplier-card>

                    <document-supplier-document-status-card
                      [form]="form"
                      [salesPersonSelect]="salesPersonSelect"
                      [readonlyForm]="entity?.deliveryStatus == SupplierDeliveryStatus.Closed"
                      class="card"
                    >
                      <div class="col-md-6 p-0" afterSalesPerson>
                        <label for="deliveryStatus" class="form-label text-primary" dwInputRequired>
                          {{ 'Doc::SupplierDeliveryNote:SupplierDeliveryStatus' | abpLocalization }}
                        </label>
                        <ng-select
                          class="form-control"
                          id="deliveryStatus"
                          formControlName="deliveryStatus"
                          bindLabel="name.current"
                          bindValue="id"
                          [items]="supplierDeliveryStatus()"
                        >
                        </ng-select>
                      </div>
                      <ng-container middle>
                        <div class="row row-cols-md-12 col-pad">
                          <div class="col-md-6 p-0">
                            <label
                              for="additionalCostPricePercentage"
                              class="form-label text-primary"
                            >
                              {{
                                'Doc::SupplierPurchaseOrder:AdditionalCostPricePercentage'
                                  | abpLocalization
                              }}
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              formControlName="additionalCostPricePercentage"
                              suffix="%"
                              mask="percent.2"
                            />
                          </div>

                          <div class="col-md-6 p-0">
                            <label for="warehouseId" class="form-label text-primary">
                              {{ 'Doc::SupplierDeliveryNote:Warehouse' | abpLocalization }}
                            </label>
                            <ng-select
                              class="form-control"
                              id="warehouseId"
                              formControlName="warehouseId"
                              bindLabel="code"
                              bindValue="id"
                              [dwApiSelect]="warehouseSelect"
                            >
                              <ng-template ng-label-tmp let-item="item">
                                <span [title]="item.name">{{ item.name }} - {{ item.code }}</span>
                              </ng-template>
                              <ng-template
                                ng-option-tmp
                                let-item="item"
                                let-index="index"
                                let-search="searchTerm"
                              >
                                <span [title]="item.name">{{ item.name }} - {{ item.code }}</span>
                              </ng-template>
                            </ng-select>
                          </div>
                        </div>
                      </ng-container>
                    </document-supplier-document-status-card>
                  </div>

                  @if (isSerialEntry) {
                    <div class="card-group mb-2 mt-2 header">
                      <div class="card p-2 border">
                        <div class="col col-md-6 p-0 d-flex align-items-end">
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="copyLineData"
                              formControlName="copyLineData"
                            />
                            <label for="copyLineData" class="form-check-label text-primary">
                              {{ 'Doc::StockDoc:CopyLineData' | abpLocalization }}
                            </label>
                          </div>
                        </div>
                        <div class="col col-md-6 p-0 d-flex align-items-end">
                          <div class="form-check form-switch">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="printLabel"
                              formControlName="printLabel"
                            />
                            <label for="printLabel" class="form-check-label text-primary">
                              {{ 'Doc::StockDoc:PrintLabel' | abpLocalization }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  @if (entity?.id) {
                    <div ngbScrollSpyFragment="products" dwScrollSpyItem [fragment]="'products'">
                      <document-supplier-delivery-note-lines-grid
                        #supplierDeliveryNoteLineGrid
                        [supplierDeliveryNote]="entity"
                        [readonly]="isClosed()"
                        [thirdPartyVatSystem]="thirdParty?.vatSystem"
                        (lineUpdatedEvent)="refreshAfterLineUpdate($event)"
                        [isSerialEntry]="isSerialEntry"
                        [copyLineData]="this.form?.get('copyLineData')?.value"
                        [printLabel]="this.form?.get('printLabel')?.value"
                        [selectedPurchaseOrderSelectedIds]="selectedPurchaseOrderSelectedIds"
                        (linePricingDetailsEvent)="updatePricingDetails($event)"
                      ></document-supplier-delivery-note-lines-grid>
                    </div>
                  }
                </form>
              </div>
            </div>
          </ng-template>
        </li>
        <li [ngbNavItem]="'conditions'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-terms me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Conditions' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <document-doc-conditions class="d-block" [docForm]="form" [docRoleInput]="docRole">
            </document-doc-conditions>
          </ng-template>
        </li>
        <li [ngbNavItem]="'classification'" [disabled]="!entity?.id">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-classifications me-2 text-primary"></i
            >{{ '::Classifications' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <document-doc-classifications
              class="d-block"
              [form]="form"
              [docClassificationValues]="docClassificationValues$ | async"
            ></document-doc-classifications>
          </ng-template>
        </li>
        <li [ngbNavItem]="'others'">
          <a ngbNavLink appDwNavLink>
            <i class="digi-out-three-points-horizontal-1 me-2 text-primary"></i
            >{{ 'Doc::CustomerQuote:Others' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <document-doc-supplier-others
              class="d-block"
              [docForm]="form"
              [docRoleInput]="docRole"
            ></document-doc-supplier-others>
          </ng-template>
        </li>
        <li [ngbNavItem]="'annexes'">
          <a ngbNavLink appDwNavLink (click)="fetchAnnexes()">
            <i class="digi-out-text-file me-2 text-primary position-relative">
              <dw-ui-counter [value]="annexesCount"></dw-ui-counter>
            </i>
            {{ 'Doc::Annexes' | abpLocalization }}
          </a>
          <ng-template ngbNavContent>
            <core-annexes-list
              class="d-block"
              [canDownload]="true"
              [canUpload]="true"
              [canDelete]="true"
              [canPreview]="true"
              [canEdit]="true"
              [folderName]="'quote-detail/' + entity?.id"
              [annexes]="annexesAsPromise$ | async"
              (createOrUpdateAnnexes)="createOrUpdateAnnexes($event)"
              (deleteAnnex)="deleteAnnex($event)"
              (deleteAnnexes)="deleteAnnexes($event)"
            ></core-annexes-list>
          </ng-template>
        </li>
      </ul>
      @if (entity?.id) {
        <dw-ui-dropdown-menu [dropdownMenu]="actions()"></dw-ui-dropdown-menu>
      }
      @if (saveActionBtns().length == 1) {
        <button
          (click)="saveActionBtns()[0].action()"
          class="btn btn-primary"
          type="submit"
          form="generalForm"
          [disabled]="saveActionBtns()[0].disabled()"
        >
          {{ saveActionBtns()[0].labelSignal() }}
        </button>
      } @else if (saveActionBtns().length > 1) {
        <div ngbDropdown #dropdown="ngbDropdown">
          <button
            type="button"
            class="btn btn-primary text-white p-2 dropdown-toggle-with-caret"
            id="dropdowntoolbar"
            ngbDropdownToggle
          >
            @if (isCreationMode()) {
              {{ '::Save' | abpLocalization }}
            } @else {
              {{ '::ToValidate' | abpLocalization }}
            }
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownActions">
            @for (btn of saveActionBtns(); track $index) {
              <button
                ngbDropdownItem
                type="submit"
                (click)="btn.action()"
                form="generalForm"
                class="d-flex align-items-center gap-2"
                [disabled]="btn.disabled()"
              >
                {{ btn.labelSignal() }}
              </button>
            }
          </div>
        </div>
      }
      <button
        (click)="validateStock()"
        class="btn btn-success ms-2"
        [disabled]="!stockValidationSharedLogicService.canStockValidate()"
      >
        {{ 'ERP::ToValidate' | abpLocalization }}
      </button>
    </div>

    <div [ngbNavOutlet]="nav" class="tab-content"></div>
  </dw-grid-tabs>

  <div side-panel-content>
    <dw-ui-side-panel #info [contentTemplate]="bodyTotal">
      <ng-template #bodyTotal>
        <document-side-panel
          #docSidePanel
          [entity]="entity"
          [docService]="docService"
          [linePricingDetails]="linePricingDetails"
          [thirdPartyContact$]="thirdPartyContact$"
          [thirdPartyDocLinkedCount]="thirdPartyDocLinkedCount"
          [contactEmail]="contactEmail"
          [contactPhone]="contactPhone"
          [customerAddress]="customerAddress"
          [accountingCustomerOutstandingDto]="accountingCustomerOutstandingDto"
          [thirdParty]="thirdParty"
          [creditLimit]="creditLimit"
          (redirectToThirdPartyEvent)="redirectToThirdParty($event.thirdPartyId, $event.addContact)"
          [dwReadonlyForm]="entity?.deliveryStatus == SupplierDeliveryStatus.Closed"
          [isStockValidatedWarning]="
            entity?.deliveryStatus == SupplierDeliveryStatus.CheckValuation
          "
        >
          <label for="note" class="form-label text-primary mt-3">{{
            'GoliathCore::Note' | abpLocalization
          }}</label>
          @if (entity != null) {
            <textarea
              name="note"
              class="flex-grow-1"
              resize="none"
              [(ngModel)]="entity.note"
              (input)="updateNote($event)"
            ></textarea>
          }
        </document-side-panel>
      </ng-template>
    </dw-ui-side-panel>
    <dw-ui-side-panel class="side-panel--full" #chatPanel [contentTemplate]="bodyChat">
      <ng-template #bodyChat>
        <dw-core-chat
          [entityId]="entity?.id"
          [entityName]="GoliathDocumentEntityNames.SupplierDeliveryNote.shortName"
          [entityReference]="entity?.displayNumber"
        ></dw-core-chat>
      </ng-template>
    </dw-ui-side-panel>
  </div>
</dw-ui-panel>
